<template lang="pug">
div
    SearchFilters
    SearchPagination
    div(v-if="selectedSearchItems.length > 0" class="text-right") 
      v-btn(
        @click="handleMailingSelectedItems"
        color="primary"
        :loading="sendingSelectedItemsToMail"
      ) Mail {{ selectedSearchItems.length }}/{{ totalSelectableItems }} selected item(s)
    SearchResults(
      :selectableItems="selectableItems"
      :totalSelectableItems="totalSelectableItems"
    )
</template>

<script>
import SearchResults from "@/components/search/SearchResults.vue";
import SearchFilters from "@/components/search/SearchFilters.vue";
import SearchPagination from "@/components/search/SearchPagination.vue";
import { mapState } from "vuex";
import { http } from "@/services/axios.config";
import appConfig from "@/services/config";

export default {
  props: {
    selectableItems: {
      type: Boolean,
      default: false,
    },
    totalSelectableItems: {
      type: Number,
      default: null,
    },
  },
  data: () => {
    return {
      sendingSelectedItemsToMail: false,
    };
  },
  destroyed() {
    this.$store.commit("search/SET_SELECTED_SEARCH_ITEMS", []);
  },
  methods: {
    async handleMailingSelectedItems() {
      if (this.selectedSearchItems.length === 0) return;
      try {
        this.sendingSelectedItemsToMail = true;
        const data = this.selectedSearchItems.reduce((result, curr) => {
          const types = curr.type === "Action" ? "actionIds" : "articleIds";
          if (!result[types]) {
            result[types] = [];
          }
          result[types].push(curr.id);
          return result;
        }, {
          queueName: "email-pdfs",
        });
        await http(
          "sendMessageToQueue",
          "post",
          data,
          null,
          null,
          appConfig.VUE_APP_JARVIS_FUNCTIONS_LINUX_ENDPOINT
        );
        this.$store.commit("search/SET_SELECTED_SEARCH_ITEMS", []);
      } catch (error) {
        this.$store.commit("showMessage", {
          content: "An error occurred sending selections",
          color: "red",
          timeout: 6000,
        });
      } finally {
        this.sendingSelectedItemsToMail = false;
      }
    },
  },
  computed: {
    ...mapState("search", ["results", "selectedSearchItems"]),
  },
  components: {
    SearchResults,
    SearchFilters,
    SearchPagination,
  },
};
</script>
